import { render, staticRenderFns } from "./MainColumnEdit.vue?vue&type=template&id=0f8e2cb9&scoped=true&"
import script from "./MainColumnEdit.vue?vue&type=script&lang=js&"
export * from "./MainColumnEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8e2cb9",
  null
  
)

export default component.exports